import CRMStatusPage from '../pages/CRM/CRMStatusPage'
import React from 'react'
import CRMConnect from '../pages/CRM/CRMConnectPage'
import PublicRoute from '../components/RouteVisibility/PublicRoute/PublicRoute'

export const CRM_CONNECT_PATH = '/crm-connect',
	CRM_STATUS_PATH = '/crm-status'

export const CRM_CONNECT_ROUTES = [
	{
		path: CRM_CONNECT_PATH,
		element: <PublicRoute />,
		children: [{ path: '', element: <CRMConnect /> }],
	},
]

export const CRM_STATUS_ROUTES = [
	{
		path: CRM_STATUS_PATH,
		element: <CRMStatusPage />,
	},
]
